
import { ImageFieldExt, MyImageFieldProps } from './ImageFieldExt';
import { photoUrl } from "../services";
import { IconButton } from '@mui/material';
import { useRecordContext } from 'react-admin';

const ImageFieldExtWithLink = (props: MyImageFieldProps) => {
   
    const record = useRecordContext(props);

    return (
        <div>
            <IconButton href={photoUrl(typeof record?.id === "string" ? record?.id : (record?._id || record?.id), "full")} target="_blank">
                <ImageFieldExt {...props} />
            </IconButton>
        </div>
    );
};

export default ImageFieldExtWithLink;